import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { ThisState } from './states'

const Report: Module<ThisState, State> = {
  state: new ThisState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default Report
